const zh = {
  name: '姓名',
  info: {
    age: '年龄小芳小名'
  }
}
export default zh
